import { BigNumber } from 'ethers'

// This number is equal to 115792089237316195423570985008687907853269984665640564039457584007913129639935, we cant use it to not lose precision on the run time
export const MAX_SUPPLY = BigNumber.from(2).pow(256).sub(1)

export const MAX_LIMIT = 9999

export const ITEMS_TO_FETCH = 20

export * from './networks'
export * from './localStorage-keys'
export * from './connectors'
export * from './externalAccounts'
